import { useEffect, useState } from 'react';
import { Modal, Input } from 'rsuite';
import Button from '../button'

function CustomModal({ title, text, confirmButtonText = 'Yes', cancelButtonText = 'No', onConfirm, onClose, open, confirmText, confirmColor="red", cancelColor="blue", loading, confirmTestId, cancelTestId }) {

    const [confirmCheck, setConfirmCheck] = useState('');

    function confirmCheckValid() {
        let disabled = false;
        if (!confirmText) {
            return disabled;
        }
        disabled = confirmCheck !== confirmText;
        return disabled;
    }

    function forceCase(text) {
        setConfirmCheck(text.toUpperCase());
    }

    useEffect(() => {
        setConfirmCheck('');
    }, [open]);

    return (
        <Modal backdrop="static" keyboard={false} open={open} onClose={onClose}>
            <Modal.Header className='modal-header'>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '16px' }}>
                    {text}
                    {confirmText &&
                        <div style={{marginTop: 16}}>
                            <span>Type <span style={{ color: 'var(--error)', fontWeight: 'bolder' }} >{confirmText}</span> in the box below to confirm.</span>
                        </div>
                    }
                </div>
                {confirmText &&
                    <div style={{ width: '100%' }}>
                        <Input style={{ width: '100%' }} value={confirmCheck} onChange={forceCase} autoComplete="off" />
                    </div>
                }
            </Modal.Body>
            <Modal.Footer className='modal-footer'>
                <Button className='beststart-button' text={confirmButtonText} color={confirmColor} onClick={onConfirm} disabled={confirmCheckValid()} loading={loading} data-testid={confirmTestId} />
                <Button className='beststart-button' text={cancelButtonText} color={cancelColor} onClick={onClose} loading={loading} data-testid={cancelTestId} />
            </Modal.Footer>
        </Modal>
    );
}

export default CustomModal;